import { Entity } from '@adornis/baseql/decorators.js';
import { BaseEditExtension } from '../BaseEditExtension.js';

/**
 * @entity BaseKPFEditAccessCodesExtension
 */
@Entity()
export class BaseKPFEditAccessCodesExtension extends BaseEditExtension {
  public static override _class = 'BaseKPFEditAccessCodesExtension';
}
